import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";
const apiUrl: string = `${hostname}/aladdin_api/v1`;

function getPsiRequestsOfCompetitors(
  oauthTokenHeader: string,
  website_shared_uid: any,
) {
  return fetchWrapper.get(
    `${apiUrl}/market_positioning/pagespeed_tests/${website_shared_uid}/`,
    oauthTokenHeader,
  );
}

function putPsiRequestOfCompetitors(
  oauthTokenHeader: string,
  website_shared_uid: any,
  psi_shared_uid: any,
  data: any,
) {
  return fetchWrapper.put(
    `${apiUrl}/market_positioning/pagespeed_tests/${website_shared_uid}/?psi=${psi_shared_uid}`,
    data,
    oauthTokenHeader,
  );
}

function getSerpCompetitors(oauthTokenHeader: string) {
  return fetchWrapper.get(
    `${apiUrl}/market_positioning/serp_competitor/`,
    oauthTokenHeader,
  );
}

function postCompetitors(
  oauthTokenHeader: string,
  website_shared_uid: any,
  data: any,
) {
  return fetchWrapper.post(
    `${apiUrl}/market_positioning/pagespeed_tests/${website_shared_uid}/`,
    data,
    oauthTokenHeader,
  );
}

function postSerpCompetitor(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/market_positioning/serp_competitor/`,
    data,
    oauthTokenHeader,
  );
}

function postCompetingCompany(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/market_positioning/competing_companies/`,
    data,
    oauthTokenHeader,
  );
}

function getCompetitorsDashboadExecuteQuery(
  oauthTokenHeader: string,
  website_shared_uid: string,
  start_date: any,
  end_date: any,
  QUERY_ID: any,
  device: any,
) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${QUERY_ID}/?start_date=${start_date}&end_date=${end_date}&website_shared_uid=${website_shared_uid}&device=${device}`,
    oauthTokenHeader,
  );
}

export const competitorsPageSpeedService = {
  getPsiRequestsOfCompetitors,
  putPsiRequestOfCompetitors,
  getSerpCompetitors,
  postCompetitors,
  postSerpCompetitor,
  postCompetingCompany,
  getCompetitorsDashboadExecuteQuery,
};
